<template>
  <v-dialog v-model="openReportVideoModel" persistent max-width="400">
    <v-card>
      <v-card-title class="gc-text-h6">{{
        lang.reports.VideoReport
      }}</v-card-title>
      <v-card-text>{{ lang.reports.AreVideo }}</v-card-text>
      <v-card-text>
          <div class="input-group" style="width: 100%">
            <label>{{ lang.reports.ReportReason }} *</label>
            <select v-model="reportReason" class="custom-select">
              <option
                v-for="(report, ind) in reportMediaItems"
                :key="ind"
                :value="report.value"
              >
                {{ report.text }}
              </option>
            </select>
          </div>
          <div class="input-group mt-3" v-if="reportReason == 'Other'">
            <label>{{ lang.reports.OtherReason }} *</label>
            <textarea
              v-model="reportOther"
              rows="4"
            ></textarea>
          </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          elevation="0"
          small
          class="primary--text"
          @click="closeReportVideo()"
        >
          {{ lang.actions.cancel }}
        </v-btn>
        <v-btn small class="ml-2 btn-bg" elevation="0" @click="reportVideo()">
          {{ lang.actions.report }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ReportVideoDialog",
  data() {
    return {
      reportReason: "",
      reportOther: "",
    };
  },
  props: {
    openReportVideoModel: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters(["rules"]),
    lang() {
      return this.$store.state.langObj || {};
    },

    reportMediaItems() {
      return [
        {
          value: "Inappropriate content",
          text: this.lang.reports.Reasons.inappropriateContent,
        },
        {
          value: "Graphic or violent imagery",
          text: this.lang.reports.Reasons.graphicOrViolentImagery,
        },
        {
          value: "Hate speech or discrimination",
          text: this.lang.reports.Reasons.hateSpeech,
        },
        {
          value: "Harassment or bullying",
          text: this.lang.reports.Reasons.harassment,
        },
        {
          value: "Spam or promotional content",
          text: this.lang.reports.Reasons.spam,
        },
        {
          value: "Privacy violation",
          text: this.lang.reports.Reasons.privacyViolation,
        },
        {
          value: "Other",
          text: this.lang.reports.Reasons.other,
        },
      ];
    },
  },
  methods: {
    closeReportVideo() {
      this.$emit("closeReportVideo");
    },
    reportVideo() {if (
        (this.reportReason &&
          this.reportReason == "Other" &&
          this.reportOther) ||
        (this.reportReason && this.reportReason != "Other")
      ) {
        this.$emit("reportVideo", this.reportReason, this.reportOther);
      } else {
        this.$store.commit("toast", {
          message: this.lang.general.fillAllFields,
          color: "red lighten-2",
        });
      }
    },
  },
};
</script>

